export { CapacityManagerView } from "./capacity-manager-view";
